module.exports = __webpack_public_path__ + "34c42d176d63d0a26e524437e24ddd2d.png";